module.exports = __webpack_public_path__ + "static/1-0bf73899eb44da7e1f0d9c7720fbb938.jpg";